import { __exports as assignment } from "../../../../../../_virtual/assignment.js";
var hasRequiredAssignment;
function requireAssignment() {
  if (hasRequiredAssignment) return assignment;
  hasRequiredAssignment = 1;
  Object.defineProperty(assignment, "__esModule", { value: true });
  assignment.Assignment = void 0;
  class Assignment {
    constructor(user, results) {
      this.timestamp = Date.now();
      this.user = user;
      this.results = results;
    }
    canonicalize() {
      var _a, _b, _c;
      let canonical = `${(_a = this.user.user_id) === null || _a === void 0 ? void 0 : _a.trim()} ${(_b = this.user.device_id) === null || _b === void 0 ? void 0 : _b.trim()} `;
      for (const key of Object.keys(this.results).sort()) {
        const variant = this.results[key];
        if (variant === null || variant === void 0 ? void 0 : variant.key) {
          canonical += key.trim() + " " + ((_c = variant === null || variant === void 0 ? void 0 : variant.key) === null || _c === void 0 ? void 0 : _c.trim()) + " ";
        }
      }
      return canonical;
    }
  }
  assignment.Assignment = Assignment;
  return assignment;
}
export {
  requireAssignment as __require
};
//# sourceMappingURL=assignment.js.map
